// QuillEditor.js
import React from "react";
import ReactQuill, { Quill } from "react-quill";
import ImageResize from "quill-image-resize-module-react";
import "react-quill/dist/quill.snow.css";

Quill.register("modules/imageResize", ImageResize);

const QuillEditor = ({ field, form, ...props }) => {
  // Registrando el módulo de redimensionamiento si no está registrado

  const { name } = field;
  const { touched, errors, setFieldValue } = form;

  const modules = {
    toolbar: {
      container: [
        [{ header: "1" }, { header: "2" }, { font: [] }],
        [{ size: [] }],
        ["bold", "italic", "underline", "strike", "blockquote"],
        [
          { list: "ordered" },
          { list: "bullet" },
          { indent: "-1" },
          { indent: "+1" },
        ],
        ["link", "image", "video"],
        [{ align: [] }],
        ["clean"],
      ],
    },
    imageResize: {
      parchment: Quill.import("parchment"), // ✅ CLAVE
      locale: {
        floatLeft: "Izquierda",
        floatRight: "Derecha",
        center: "Centro",
        justify: "Justificado",
        restore: "Restaurar",
      },
    },
  };

  // Manejar cambios en el editor
  const handleChange = (content, delta, source, editor) => {
    setFieldValue(name, content);
  };

  // Manejar el evento de desenfoque
  const handleBlur = () => {
    form.handleBlur({ target: { name } });
  };

  return (
    <div className="quill-editor-container">
      <ReactQuill
        theme="snow"
        value={field.value || ""}
        onChange={handleChange}
        onBlur={handleBlur}
        modules={modules}
      />
      {touched[name] && errors[name] && (
        <div style={{ color: "red" }}>{errors[name]}</div>
      )}
    </div>
  );
};

export default QuillEditor;
